<template>
  <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition">
    <template v-slot:activator="{ on, attrs }">
      <slot name="activator" v-bind="{ on, attrs }">
        <v-btn text v-on="on" v-bind="attrs" class="mt-2">
          <v-icon color="secondary">mdi-dots-horizontal</v-icon>
        </v-btn>
      </slot>
    </template>

    <v-toolbar dark color="primary" class="mx-auto">
      <v-btn icon dark @click="dialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        class="mr-5"
        color="white"
        outlined
        dark
        v-on:click="generateJpeg(provider_data.PROVIDER_NAME)"
      >
        <v-icon>mdi-content-save</v-icon>
        <span class="pl-3">Export</span>
      </v-btn>
    </v-toolbar>

    <v-card tile :id="provider_data.PROVIDER_NAME">
      <v-skeleton-loader :loading="loading" height="81" width="500" type="list-item-two-line">
        <v-card-title>
          <h1 class="display-2">
            {{ provider_data.PROVIDER_NAME }}
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  class="py-3 pl-5 float-right"
                  :color="getProviderStatus()"
                  >mdi-circle</v-icon
                >
              </template>
              <span>{{ getProviderStatusTooltip() }}</span>
            </v-tooltip>
          </h1>
          <!-- Start Date Picker -->
          <v-row v-if="selectedTab != 'Open Conditions'" class="justify-end mt-5 mt-lg-0">
            <v-spacer></v-spacer>
            <v-col cols="6" lg="3" class="py-0">
              <v-menu transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="startDate"
                    label="Start Date"
                    append-icon="mdi-calendar"
                    outlined
                    dense
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startDate"
                  show-current="false"
                  type="month"
                  :hide-details="false"
                  no-title
                  scrollable
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6" lg="3" class="py-0">
              <!-- End Date Picker -->
              <v-menu transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="endDate"
                    label="End Date"
                    append-icon="mdi-calendar"
                    outlined
                    dense
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="endDate"
                  show-current="false"
                  type="month"
                  :hide-details="false"
                  no-title
                  scrollable
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-title>
      </v-skeleton-loader>

      <v-tabs v-model="tab" background-color="transparent" grow>
        <v-tab v-for="item in items" :key="item" @click="setSelectedTab(item)">{{ item }}</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab" id="capture">
        <v-tab-item v-for="item in items" :key="item">
          <template v-if="item == 'Report Card' && provider_data.length != 0">
            <v-row class="pa-6 pb-0">
              <v-col cols="12" lg="4">
                <v-card class="fill-height">
                  <v-card-title> Provider Info </v-card-title>
                  <v-list class="pt-0">
                    <v-list-item>
                      <v-list-item-content>Insurance:</v-list-item-content>
                      <v-chip>{{ provider_data.PLAN }}</v-chip>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>Group name:</v-list-item-content>
                      <v-chip>{{ provider_data.GROUP_NAME }}</v-chip>
                    </v-list-item>
                    <v-list-item v-if="provider_data.PROVIDER_LOCATION">
                      <v-list-item-content>Location:</v-list-item-content>
                      <v-chip>{{ provider_data.PROVIDER_LOCATION }}</v-chip>
                    </v-list-item>
                    <v-list-item v-if="providerBoardCertified">
                      <v-list-item-content>Board Certified:</v-list-item-content>
                      <v-chip>Yes</v-chip>
                    </v-list-item>
                    <v-list-item v-if="providerAcceptingNewPatients">
                      <v-list-item-content>Accepting New Patients:</v-list-item-content>
                      <v-chip>Yes</v-chip>
                    </v-list-item>
                    <v-list-item v-if="providerLanguages">
                      <v-list-item-content>Languages:</v-list-item-content>
                      <v-chip>{{ providerLanguages }}</v-chip>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
              <!-- <v-col cols="12" lg="8">
                <Chronic
                  :group="[]"
                  :providers="[provider_data]"
                  :locations="[]"
                  :insurance="insurance"
                  :startDate="startDate"
                  :endDate="endDate"
                  :visible="true"
                  :forProviderModal="true"
                />
              </v-col>

              <v-col cols="12">
                <v-card>
                  <v-card-title> Provider KPI </v-card-title>
                  <v-col v-if="load" cols="12" class="text-center">
                    <v-progress-circular
                      color="secondary"
                      indeterminate
                      :size="50"
                      :width="3"
                    ></v-progress-circular>
                  </v-col>
                  <kpi
                    :organization="[]"
                    :group="provider_data.GROUP_NAME"
                    :groupNum="provider_data.GROUP_ID"
                    :groupObject="[]"
                    :locations="[]"
                    :providers="provider_data"
                    :insurance="provider_data.PLAN"
                    :startDate="startDate"
                    :endDate="endDate"
                    :hideToolbar="true"
                    :runOnMounted="true"
                    :xlColWidth="2"
                    :kpiData="kpiData"
                  />
                </v-card>
              </v-col> -->

              <v-col cols="12">
                <FundingExpense
                  :organization="[]"
                  :groups="provider_data.GROUP_ID"
                  :groupObject="provider_data.GROUP_ID"
                  :providers="provider_data"
                  :locations="[]"
                  :insurance="provider_data.PLAN"
                  :startDate="startDate"
                  :endDate="endDate"
                />
              </v-col>
            </v-row>
          </template>

          <institutional
            v-if="item == 'Institutional'"
            :provider="provider_id"
            :insurance="insurance"
            :startDate="startDate"
            :endDate="endDate"
          />

          <professional
            v-if="item == 'Professional'"
            :provider="provider_id"
            :insurance="insurance"
            :startDate="startDate"
            :endDate="endDate"
          />

          <rx
            v-if="item == 'Rx'"
            :provider="provider_id"
            :insurance="insurance"
            :startDate="startDate"
            :endDate="endDate"
          />

          <laboratory
            v-if="item == 'Laboratory'"
            :provider="provider_id"
            :insurance="insurance"
            :startDate="startDate"
            :endDate="endDate"
          />

          <HCC v-if="item == 'Open Conditions'" :provider="provider_id" :insurance="insurance" />

          <QualityGaps
            v-if="item == 'Quality'"
            :provider="provider_id"
            :insurance="insurance"
            :startDate="startDate"
            :endDate="endDate"
          />

          <v-row v-if="item == 'Notifications'" class="pa-6">
            <v-col cols="12">
              <Notifications
                :startDate="startDate"
                :endDate="endDate"
                :insurance="insurance"
                :provider="provider_id"
              />
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';

import * as htmlToImage from 'html-to-image';
import kpi from './financeComponents/Kpi.vue';
import FundingExpense from './financeComponents/FundingExpense.vue';
import Chronic from './dashboardCharts/Chronic.vue';
import Institutional from './providerinfo/Institutional.vue';
import Professional from './providerinfo/Professional.vue';
import Rx from './providerinfo/Rx.vue';
import Laboratory from './providerinfo/Laboratory.vue';
import HCC from './providerinfo/HCC.vue';
import QualityGaps from './providerinfo/QualityGaps.vue';
import Notifications from './notificationsComponents/Notifications.vue';

export default {
  name: 'ProviderModal',
  props: ['provider', 'insurance', 'group'],
  data() {
    return {
      startDate: '2023-01',
      endDate: new Date().toISOString().substr(0, 7),
      dialog: false,
      loading: false,
      tab: null,
      load: false,
      selectedTab: '',
      provider_id: null,
      provider_data: [],
      kpiData: [],
      items: [
        'Report Card',
        'Institutional',
        'Professional',
        'Rx',
        'Laboratory',
        'Open Conditions',
        'Quality',
        'Notifications',
      ],
    };
  },
  components: {
    kpi,
    FundingExpense,
    Institutional,
    Professional,
    Rx,
    Laboratory,
    HCC,
    QualityGaps,
    Notifications,
    Chronic,
  },
  methods: {
    generateJpeg(id) {
      htmlToImage.toJpeg(document.getElementById(id), { quality: 0.95 }).then((dataUrl) => {
        const link = document.createElement('a');
        link.download = 'Provider_Report_Card' + '.jpeg';
        link.href = dataUrl;
        link.click();
      });
    },
    async getProvider() {
      this.loading = true;
      this.provider_data = [];

      const url = `api/provider/${this.provider_id}`;
      axios.get(url).then((response) => {
        [this.provider_data] = response.data;
        this.loading = false;
      });
    },
    async getKpiData() {
      this.load = true;
      this.kpiData = [];
      const url = `api/kpi/groups=${this.provider.Center_PCP_Number}/providers=${this.provider_id}/locs=/${this.insurance}/${this.startDate}/${this.endDate}`;
      await axios.get(url).then((response) => {
        this.kpiData = response.data;
        this.load = false;
      });
    },
    getProviderStatus() {
      if (new Date(this.provider.EFFECTIVE_END_DATE) > new Date()) {
        return 'success';
      }else if(this.provider.EFFECTIVE_END_DATE === null){
        return 'warning'
      }
      return 'error';
    },
    getProviderStatusTooltip() {
      if (new Date(this.provider.EFFECTIVE_END_DATE) > new Date()) {
        return 'Active';
      }else if(this.provider.EFFECTIVE_END_DATE === null){
        return 'Unknown'
      }
      return 'Termed';
    },
    setSelectedTab(tab) {
      this.selectedTab = tab;
    },
  },
  watch: {
    async dialog() {
      // make sure dialog is open before grabbing provider_id
      if (this.dialog === true) {
        this.provider_id = this.provider.PROVIDER_ID;
      }
    },
    async provider_id() {
      if (this.provider_id != null) {
        this.getProvider();
        // this.getKpiData();
      }
    },
    async startDate() {
      this.getKpiData();
    },
    async endDate() {
      this.getKpiData();
    },
  },
};
</script>

<style>
.v-dialog--fullscreen {
  overflow-x: hidden !important;
}
</style>
